import React from 'react';

import SelectItem from './../selects/SelectItem';
import {flaps} from '../../utils/flaps/flaps'
import {variableFlaps} from '../../utils/flaps/flaps-variable';

export default class ModalSink extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            options: {
                cutout: "",
                height: "",
                countCup: "",
                position: "",
                flap: ""
            },
            currentOptions: {
                cutout: '',
                height: '',
                countCup: '',
                position: '',
                flap: 'Не выбрано',
            },
            validFields: {
                cutout: false,
                height: false,
                countCup: false,
                position: false,
                flap: true,
            },
            allValid: false,
        }
    }

    async componentDidMount() {
        this._initParameters(this.props.currentSinkList);
    }


    componentDidUpdate(prevProps, prevState) {
        if(JSON.stringify(prevState.currentOptions) !== JSON.stringify(this.state.currentOptions)) {
            this._validateFields();
        }
    }

    async _initParameters(sinks) {
        this.props.updatePreloader(true);
        
        this.props.updatePreloader(false);
        const checkTwoCup = !!sinks.find(sink => {
            return sink.count_cup === 2
        })
        let checkFlaps = variableFlaps.find(item => {
            return sinks[0].name.includes(item.name) && item.type === '+'
        }) || false;
        

        let optionPosition = this.props.config.stand.stand.position_sink.map(position => {
            return {
                label: position === 'L' ? 'Слева' : position === 'R' ? 'Справа' : position === 'C' ? 'Центр' : '', 
                value: position
            }
        })

        optionPosition = optionPosition.filter(item => {
            const checkStandPosition = this.props.config.stand.positionStand === false || this.props.config.stand.positionStand === 'R' && (item.value === 'R' || item.value === 'C') || (this.props.config.stand.positionStand === 'L' && (item.value === 'L' || item.value === 'C'))
            return item.label !== ''  && checkStandPosition ;
        })

        const optionFlaps = [];
        if(checkFlaps) {
            optionFlaps.push({
                label: 'Не выбрано',
                value: 'Не выбрано',
            })
            flaps.forEach(flap => {
                optionFlaps.push({
                    label: flap.name,
                    value: flap.article
                })
            })
        }

        const cutout = [];
        const height = [];


        this.props.config.stand.stand.sinks.forEach(sink => {
            sinks.forEach(sinkItem => {
                if(sink === sinkItem.mm12.code) {
                    height.push({label: '12mm', value: 'mm12'})
                }
                if(sink === sinkItem.mm100.code) {
                    height.push({label: '100mm', value: 'mm100'})
                }
                if((sink === sinkItem.mm100.code || sink === sinkItem.mm12.code) && sink.includes('W.')) {
                    cutout.push({label: 'Без выреза', value: false})
                }
                if((sink === sinkItem.mm100.code || sink === sinkItem.mm12.code) && !sink.includes('W.')) {
                    cutout.push({label: 'С вырезом', value: true})
                }
            })
        })

        let uniqueCutout = cutout.filter((obj, index, self) => {
            return index === self.findIndex((t) => (
              t.id === obj.id && t.label === obj.label
            ));
        });

        let uniqueheight = height.filter((obj, index, self) => {
            return index === self.findIndex((t) => (
              t.id === obj.id && t.label === obj.label
            ));
        });

        let options = {
            cutout: uniqueCutout,
            height: uniqueheight,
            countCup: checkTwoCup ? [{label: '1', value: 1}, {label: '2', value: 2}] : null,
            position: optionPosition,
            flap: optionFlaps,
        }

        this.setState(state => {
            return {
                options: options
            }
        })
    }

    initOptionCups(sinks, options) {
        const checkTwoCup = !!sinks.find(sink => {
            return sink.count_cup === 2
        })
        const optionsNew = {...options}
        const optionCups =  checkTwoCup ? [{label: '1', value: 1}, {label: '2', value: 2}] : null;
        optionsNew.countCup = optionCups;
        this.setState(state => {
            return {
                options: optionsNew
            }
        })
    }

    initOptionCutout(sinks, options) {
        const newOptions = {...options};
        const cutout = [];
        this.props.config.stand.stand.sinks.forEach(sink => {
            sinks.forEach(sinkItem => {
                if((sink === sinkItem.mm100.code || sink === sinkItem.mm12.code) && sink.includes('W.')) {
                    cutout.push({label: 'Без выреза', value: false})
                }
                if((sink === sinkItem.mm100.code || sink === sinkItem.mm12.code) && !sink.includes('W.')) {
                    cutout.push({label: 'С вырезом', value: true})
                }
            })
        })

        let uniqueCutout = cutout.filter((obj, index, self) => {
            return index === self.findIndex((t) => (
              t.id === obj.id && t.label === obj.label
            ));
        });

        newOptions.cutout = uniqueCutout;
        this.setState(state => {
            return {
                options: newOptions
            }
        })
        
    }

    setCutout(value) {
        if(value) {
            const options = JSON.parse(JSON.stringify(this.state.currentOptions))
            options.cutout = value.value;
            this.setState(state => {
                return {
                    currentOptions: options
                }
            }, () => {
                this.initOptionCups(this._searchSink().filterSinks, this.state.options)
            })
        }
        
    }

    setHeight(value) {
        if(value) {
            const options = JSON.parse(JSON.stringify(this.state.currentOptions))
            options.height = value.value;
            this.setState(state => {
                return {
                    currentOptions: options
                }
            })
        }
    }

    setCountCup(value) {
        if(value) {
            const options = JSON.parse(JSON.stringify(this.state.currentOptions))
            options.countCup = value.value;
            if(value.value === 2) {
                options.position = "D";
            }
            if(value.value === 1) {
                options.position = '';
            }
            this.setState(state => {
                return {
                    currentOptions: options
                }
            }, () => {this.initOptionCutout(this._searchSink().countCupFilterSinks, this.state.options)})
        }
    }

    setPosition(value) {
        if(value) {
            const options = JSON.parse(JSON.stringify(this.state.currentOptions))
            options.position = value.value;
            this.setState(state => {
                return {
                    currentOptions: options
                }
            })
        }
    }

    setFlaps(value) {
        if(value && value.value !== '') {
            const options = JSON.parse(JSON.stringify(this.state.currentOptions))
            options.flap = value.value;
            this.setState(state => {
                return {
                    currentOptions: options
                }
            })
        }
    }

    _validateFields() {
        const copyValidateObject = JSON.parse(JSON.stringify(this.state.validFields));
        const currentOptions = this.state.currentOptions;
        for(let key in currentOptions) {
            if(currentOptions[key]!=='' || this.state.options[key] === null) {
                copyValidateObject[key] = true;
            }
            else {
                copyValidateObject[key] = false;
            }
        }
        
        let checkAllValidate = true;

        for(let key in copyValidateObject) {
            if(copyValidateObject[key] === false) {
                checkAllValidate = false;
            }
        }

        if(checkAllValidate) {
            this.props.updateValidate('sink', true);
            this.props.updatePrice(Number(this._searchSink().currentSink[this.state.currentOptions.height].price) + ((this.state.currentOptions.countCup === 2 ? 2 : 1) * Number(this._searchFlaps(this.state.currentOptions.flap))))
        }
        else this.props.updateValidate('sink', false);
    
        this.setState(state => {
            return {
                validFields: copyValidateObject,
                allValid: checkAllValidate
            }
        })
    }

    _searchFlaps(article) {
        const currentFlap = flaps.filter(flap => {
            return flap.article === article;
        })
        return currentFlap[0] ? currentFlap[0].price : 0;

    }

    _searchSink() {
        let currentSink = {}
        let sinks = this.props.currentSinkList;
        const cutoutFilter = sinks.filter(sink => {
            if(this.state.currentOptions.cutout) {
                return sink.mm12.code.indexOf('W.') === -1
            }
            else {
                return sink.mm12.code.indexOf('W.') !== -1
            }
        });

        const countCupFilter = cutoutFilter.filter(sink => {
            if(this.state.options.countCup===null) {
                return true;
            }
            else {
                return this.state.currentOptions.countCup === sink.count_cup;
            }
        })
        currentSink = countCupFilter;
        return {currentSink: currentSink[0], filterSinks: cutoutFilter, countCupFilterSinks: countCupFilter};

    }

    setSink() {
        let copyConfiguration = JSON.parse(JSON.stringify(this.props.srcConfig));
        const currentSink = this._searchSink().currentSink;
        copyConfiguration.tabletop = false;
        copyConfiguration.sink = {
            article: currentSink[this.state.currentOptions.height].code,
            position: this.state.currentOptions.position,
            flap: this.state.currentOptions.flap === 'Не выбрано' ? false : this.state.currentOptions.flap,
        }
        this.props.setConfiguration(copyConfiguration);
    }


    render() {
        return (
            <>
                <div className='modal-window__controls'>
                    {window.innerWidth >= 1200  ? '' : <h2 className='modal-window__controls-title'>Выберите параметры:</h2>}

                    <div className={`modal-window__control`}>
                        <SelectItem 
                            handleChange = {this.setCutout.bind(this)}
                            options = {this.state.options.cutout}
                            placeholder="Вырез под смеситель" 
                            validate={this.props.validateParts ? this.state.validFields.cutout : true}
                        />
                    </div>
                    <div className={`modal-window__control`}>
                        <SelectItem 
                            handleChange = {this.setHeight.bind(this)}
                            options = {this.state.options.height}
                            placeholder="Толщина изделия"
                            validate={this.props.validateParts ? this.state.validFields.height : true}
                        />
                    </div>
                </div>
                {
                    this.state.options.countCup !== null ? 
                    <div className={`modal-window__control modal-window__control--one `}>
                        <SelectItem 
                            handleChange = {this.setCountCup.bind(this)}
                            options = {this.state.options.countCup}
                            placeholder="Количество чаш"
                            validate={this.props.validateParts ? this.state.validFields.countCup : true}
                        />
                    </div>
                    :
                    <></>
                }
                <div className={`modal-window__control modal-window__control--one`}>
                    {
                        this.state.currentOptions.countCup === 2 ?
                        <></>
                        :
                        <SelectItem 
                            handleChange = {this.setPosition.bind(this)}
                            options = {this.state.options.position}
                            placeholder="Расположение чаши"
                            validate={this.props.validateParts ? this.state.validFields.position : true}
                        />
                    }
                    
                </div>
               
                {
                    this.state.options.flap.length > 0 ?
                    <div className={`modal-window__control modal-window__control--one`}>
                        <SelectItem 
                            handleChange = {this.setFlaps.bind(this)}
                            options = {this.state.options.flap}
                            placeholder="Донный клапан"
                            validate={true}
                        />
                    </div>
                    :
                    <></>
                }
            </>
        )
    }
}
